export enum RecoveryScope {
    Recovery = 'SCOPE_RECOVERY',
    BookingInsertRecovery = 'SCOPE_BKN_INSERT_RECOVERY',
    RaInsertRecovery = 'SCOPE_RA_INSERT_RECOVERY',
    RaInsertCheckInRecovery = 'SCOPE_RA_INSERT_CHECK_IN_RECOVERY',
    RaInsertCheckOutRecovery = 'SCOPE_RA_INSERT_CHECK_OUT_RECOVERY',
    SignInsertRecovery = 'SCOPE_SIGN_INSERT_RECOVERY',
    SubstitutionBookingRecovery = 'SCOPE_BKN_SUB_INSERT_RECOVERY'
}
